import { createClient } from '@supabase/supabase-js';

const supabaseClient = createClient(
    "https://flcyizfbidslcfjrrugs.supabase.co",
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZsY3lpemZiaWRzbGNmanJydWdzIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTczMDYwNTAwMCwiZXhwIjoyMDQ2MTgxMDAwfQ.4APkhyqKlgrJo1yIUhWUblw0fwUvzOFDU4Uq64Sb3-Q"
);

export default supabaseClient;